/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { backgroundColor, } from './style.js'
import React from 'react'
import { Account } from './account'
import { Form } from './form'
import { Snapshot } from './snapshot'
import { Header } from './header'
import { Footer } from './footer'
import { Loading } from '../twd'
import { useOrderTicket, } from './use-order-ticket'

export const Entry = () => {

    return <React.Fragment>
        <div className="order-ticket">
        <div className="container">
        <Header />
        </div>

        <div style={{backgroundColor:"#f6f6f6"}}>
        <div className="container">
            <Account />
        </div>
        </div>

        <div css={backgroundColor}>
        <div className="container">
            <Content />
        </div>
        </div>

        <Footer />
        </div>
        </React.Fragment>
}

const Content = () => {
    const { orderInfoStatus } = useOrderTicket()

    return  <Loading status={orderInfoStatus}>
        <div className="row">
        <div className="col-md-6 col-xs-12">
            <Form />
        </div>
        <div className="col-md-6 col-xs-12">
            <Snapshot />
        </div>
        </div>
        </Loading>
}


// WEBPACK FOOTER //
// ./src/order-ticket/entry.js